import {
  MAILHOSTING_DOMAIN_INIT_DB,
  MAILHOSTING_DOMAIN_SET_CUSTOMER_URL,
  MAILHOSTING_DOMAIN_SET_LIST,
  MAILHOSTING_DOMAIN_START_LOADING,
  MAILHOSTING_DOMAIN_STOP_LOADING
} from 'mailhosting/domain/actions'

import { MAILHOSTING_DOMAIN_REL } from 'product/resources'
import { createNextState } from '@reduxjs/toolkit'
import initialDomainState from 'mailhosting/domain/db'
import initialState from 'mailhosting/db'
import setIn from 'lodash/set'

const getBaseKeyPath = (companyKey) => ['companies', companyKey, MAILHOSTING_DOMAIN_REL]
const getKeyPath = (companyKey, subKey) => getBaseKeyPath(companyKey).concat([subKey])
const getListKeyPath = (companyKey) => getKeyPath(companyKey, 'list')

const reducers = {
  [MAILHOSTING_DOMAIN_START_LOADING]: (mailhostingDb, action) => {
    return setIn(mailhostingDb, getKeyPath(action.companyKey, 'loading'), true)
  },

  [MAILHOSTING_DOMAIN_STOP_LOADING]: (mailhostingDb, action) => {
    return setIn(mailhostingDb, getKeyPath(action.companyKey, 'loading'), false)
  },

  [MAILHOSTING_DOMAIN_SET_LIST]: (mailhostingDb, action) => {
    return setIn(mailhostingDb, getListKeyPath(action.companyKey), action.list)
  },

  [MAILHOSTING_DOMAIN_INIT_DB]: (mailhostingDb, action) => {
    return setIn(mailhostingDb, getBaseKeyPath(action.companyKey), initialDomainState)
  },

  [MAILHOSTING_DOMAIN_SET_CUSTOMER_URL]: (mailhostingDb, action) => {
    return setIn(
      mailhostingDb,
      getKeyPath(action.companyKey, 'customerUrl'),
      action.customerUrl
    )
  }
}

export default function (moduleDb = initialState, action = {}) {
  return createNextState(moduleDb, (draftState) => {
    const reducer = reducers[action.type]

    if (!reducer) return draftState

    return reducer(draftState, action)
  })
}
